import React from 'react';
import PropTypes from 'prop-types';
import * as style from "./style.module.css";

const YouTubeEmbed = ({ videoId,  autoplay="1"}) => {
  const embedUrl = `https://www.youtube.com/embed/${videoId}&autoplay=${autoplay}&controls=1&mute=1`;
  return (
    <div className={style.youtube_box}>
      <iframe
        src={embedUrl}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="YouTube video"
      ></iframe>
    </div>
  );
};

YouTubeEmbed.propTypes = {
  videoId: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
};

export default YouTubeEmbed;